<template>
    <div class="card col-md-12 mx-auto">
        <div class="card-header card-header bg-primary text-white h4 m-0">
            <page-title :title="claimName + ' / ' + ($t(titleKey)) + ' / ' + ($t('sideMenu.participationType'))"></page-title>
        </div>

        <div class="card-body" v-if="hasItems" v-cloak>
            <div v-cloak>
                <div class="btn-group" role="group">
                    <button type="button"
                            class="btn btn-primary"
                            @click="redirectToList">
                        <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                    </button>
                </div>
                <div class="input-group col-sm-4 col-md-3 float-right btn-group">
                    <div class="input-group-addon fas fa-search text-primary" style="display:table-cell"></div>
                    <input class="form-control fa fa-search" name="query" v-model="searchQuery">
                </div>
            </div>
            <custom-grid :data="claims"
                         :columns="gridColumns"
                         :filter-key="searchQuery"
                         :captions="gridCaptions"
                         :gridName="'RoleClaims'"
                         :readonly="!hasEditRights || working">
            </custom-grid>
        </div>
        <div class="card-body" v-else v-cloak>
            <div class="alert alert-warning" role="alert">
                <h4>
                    Липсват данни.
                </h4>
            </div>
        </div>
    </div>



</template>

<script>
    import CustomGrid from "../../../components/grid/CustomGrid";
    import PageTitle from '../../../components/common/PageTitle';
    import bus from '../../../components/sidemenu/event-bus';
    import { Culture } from '../../../models/enums';
    import { Role } from '../../../helpers/role';

    export default {
        components: {
            CustomGrid,
            PageTitle
        },
        props: {
            id: String
        },
        created() {
            this.bus = bus;
            this.bus.$on('checkbox-changed', (claim, gridName) => {
                if (gridName === 'RoleClaims') {
                    this.toggleRoleClaim(claim);
/*                    if (this.id && claim.hasOwnProperty('roleId') && claim.hasOwnProperty('claimId')
                        && claim.claimId > 0 && this.id === claim.roleId) {
                        this.toggleRoleClaim(claim);
                    }*/
                }
            });
        },
        beforeDestroy() {
            this.bus.$off('checkbox-changed');
        },
        data() {
            return {
                componentName: "RoleClaimsList",
                titleKey: 'sideMenu.claims', // Трабва на конпонентата за бутоните за дашборд настройките
                loading: false,
                working: false,
                gridCaptions: {
                    roleClaimId: 'editor.common.id',
                    claimName: 'editor.common.name',
                    claimNormalizedName: 'editor.common.normalizedName',
                    claimLabel: 'editor.common.label',
                    claimLabelEn: 'editor.common.labelEn',
                    create: 'editor.common.create',
                    read: 'editor.common.read',
                    update: 'editor.common.update',
                    delete: 'editor.common.delete',
                },
                gridColumns: ['claimName', 'claimNormalizedName', 'claimLabel', 'claimLabelEn', 'create', 'read', 'update', 'delete'],
                claims: [{
                    roleClaimId: 0,
                    claimId: 0,
                    claimName: '',
                    claimNormalizedName: '',
                    claimLabel: '',
                    claimLabelEn: '',
                    claimDeactivated: false,
                    ClaimNote: '',
                    roleId: '',
                    userId: '',
                    roleName: '',
                    roleDescription: '',
                    uuserName: '',
                    create: false,
                    read: false,
                    update: false,
                    delete: false,
                }],
                searchQuery: '',
                claimName: '',
                roleDescription: ''
            };
        },
        methods: {
            loadData: function () {
                this.loading = true;

                return this.$http.get(`/api/ParticipantsClaims/ListParticipationClaims/${this.id}`
                ).then((response) => {
                    this.claims = response.data.participationClaims;
                    this.claimName = response.data.claimName
                    this.roleDescription = response.data.roleDescription

                    this.loading = false;
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })

                    this.loading = false;
                })
            },
            toggleRoleClaim(claim) {
                if (!this.hasEditRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.working = true;
                this.$http.post(`/api/ParticipantsClaims/toggleClaim`, claim)
                    .then(response => {
                        // TODO: Add id
                        claim.id = response.data.id;

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                            position: 'top-center',
                        })
                    }).catch(error => {
                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration,
                            position: 'top-center',
                        })
                    })
                    .then(() => { this.working = false; });;
            },
            redirectToList() {
                this.$router.push({ path: '/administration/participantsClaims' });
            }

        },
        mounted: function () {
            if (!this.isNew) {
                this.loadData();
            }

            const container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({ container });
        },
        computed: {
            token: function () {
                return this.$store.getters.authToken;
            },
            hasItems() {
                return Array.isArray(this.claims) && this.claims.length;
            },
            isNew: function () {
                return this.id === undefined;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
            hasEditRights() {
                return this.$store.getters.claims.claimsAdministration.update;
            },
        }
    }
</script>

<style scoped>
</style>
